import { DealerActions, DealerActionsType } from './DealerActions';

export type TurnDealerState = {
  years: readonly number[];
  models: readonly string[];
  trims: readonly string[];
  brands: readonly string[];
};

export const initialTurnDealerState: TurnDealerState = {
  years: [],
  models: [],
  trims: [],
  brands: [],
};

export const turnDealerReducer = (
  state: TurnDealerState = initialTurnDealerState,
  action: DealerActions,
): TurnDealerState => {
  switch (action.type) {
    case DealerActionsType.SET_YEARS:
      return {
        ...state,
        years: action.payload,
      };
    case DealerActionsType.SET_BRANDS:
      return {
        ...state,
        brands: action.payload,
      };
    case DealerActionsType.SET_MODELS:
      return {
        ...state,
        models: action.payload,
      };
    case DealerActionsType.SET_TRIMS:
      return {
        ...state,
        trims: action.payload,
      };
    case DealerActionsType.RESET_DEALER:
      return {
        trims: initialDealerState.trims,
        years: initialDealerState.years,
        models: initialDealerState.models,
        brands: initialDealerState.brands,
      };
    default:
      return state;
  }
};
